import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, OnInit} from '@angular/core';
import {BaseFieldComponent} from './base-field.component';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';

/**
 * Кнопка сброса значения для поля формы, которая отображается только если значение есть
 */

@Component({
    selector: 'app-form-filed-reset-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <button type="button"
                class="button button--icon"
                [class.button--small]="small"
                [style.visibility]="getVisibility()" style="fill-opacity: 0.5">
            <lib-icon type="cross" [size]="13"></lib-icon>
        </button>
    `
})

export class FormResetButtonComponent extends BaseFieldComponent implements OnInit {
    @Input() small = false;

    private isValue = false;

    getVisibility() {
        return this.isValue ? 'visible' : 'hidden';
    }

    constructor(
        private cd: ChangeDetectorRef,
    ) {
        super();
    }

    ngOnInit() {
        this.isValue = this.fbControl.value !== null && this.fbControl.value !== '';

        this.subs.push(
            this.fbControl.valueChanges.pipe(
                debounceTime(30),
                distinctUntilChanged(),
                map((v: any) => v !== null && v !== '')
            ).subscribe((isValue: boolean) => {
                this.isValue = isValue;
                this.cd.detectChanges();
            })
        );
    }

    @HostListener('click')
    onClick() {
        if (this.isValue) {
            this.fbControl.patchValue('');
            this.fbControl.markAsDirty();
            this.fbControl.markAsTouched();
            this.fbControl.updateValueAndValidity();
        }
    }
}
